<template>
  <router-link v-if="menu_row.type === 0" class="navbar-item" v-show="menu_row.show === 1" :to="menu_row.path" v-text="menu_row.title"></router-link>
  <div v-else :class="{'navbar-item has-dropdown': true, 'is-active': menu_row.dropdown_active}" @click="openDropdown()">
    <router-link class="navbar-link" v-show="menu_row.show === 1" :to="menu_row.path" v-text="menu_row.title"></router-link>
    <div class="navbar-dropdown is-boxed">
      <router-link v-for="(menu_row_sub, index_sub) in menu_row.sub" :key="index_sub" class="navbar-item" v-show="menu_row_sub.show === 1" :to="menu_row_sub.path" v-text="menu_row_sub.title"></router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      index: 0,
      menu_row: {}
    }
  },
  created () {
    this.menu_row = this.menuRow
    this.index = this.dataIndex
  },
  props: [
    'dataIndex',
    'menuRow'
  ],
  watch: {
    menuRow (value) {
      this.menu_row = value
    },
    dataIndex (value) {
      this.index = value
    }
  },
  methods: {
    openDropdown () {
      this.$emit('open-dropdown', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/components/MenuItem.vue